<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToCascaderItem'
});
</script>
<template>
	<div class="to-cascader-group">
		<div class="to-cascader-group-content">
			<div v-for="item in data" :key="item[pProps.props.valueText]" class="to-cascader-item" :class="item.isSelect ? 'is-on' : ''" @click="handleChildClick(item)">
				<slot>
					<div class="to-cascader-item-content">{{ item[pProps.props.labelText] }}</div>
					<to-icon v-if="item[pProps.props.childrenText] && item[pProps.props.childrenText].length" value="next" class="to-cascader-item-arrow"></to-icon>
				</slot>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { ProvideProps, Item } from './cascader.vue'
import { ToIcon } from '@touchvue/components'



export interface ItemProps {
	data: Item[]
}

withDefaults(defineProps<ItemProps>(), {
	data: () => [{ label: '', value: '' }]
})
const pProps = inject<ProvideProps>('pProps')
const emit = defineEmits<{
	select: [item: Item]
}>()

function handleChildClick(item: Item) {
	emit('select', item)
}
</script>
